<template>
    <div class="w-full pb-28 md:pb-0">
        <div class="flex flex-col items-start justify-start gap-2 w-full pb-8 md:pb-6">
            <h1 class="self-stretch text-[24px] leading-8 md:text-[30px] md:leading-9 font-semibold text-slate-800">
                What are your home airports?
            </h1>
        </div>
        <div class="flex flex-col items-start gap-4 w-full">
            <div
                v-for="i in Math.max(1, airportInputs)"
                :key="i"
                class="w-full"
            >
                <div
                    class="quiz-airport px-1 py-1 relative w-full border rounded bg-white"
                    :class="airportHasError ? 'border-red-500' : 'border-slate-200'"
                >
                    <LoungesAutoSuggest
                        :recentSearches="[]"
                        :inputValue="selectedAirports[i - 1]?.name || ''"
                        valueKey="code"
                        displayKey="name"
                        placeholder="Select airport"
                        @change="(val) => onAirportChange(val, i - 1)"
                        @select="(airport) => onAirportSelected(airport, i - 1)"
                        @submit="(airport) => onAirportSelected(airport, i - 1)"
                    />
                </div>
                <div v-if="i === 1 && errors.length > 0" class="w-full">
                    <Errors :errors="errors" />
                </div>
            </div>

            <button
                type="button"
                class="inline-flex items-center gap-2 text-slate-800 font-medium"
                @click="airportInputs++"
            >
                <Icon icon="plus" />
                <span>Add airport</span>
            </button>
        </div>

        <QuizActionBar
            primaryLabel="Continue"
            secondaryLabel="Skip"
            :disabled="saving"
            @primary="saveAirport"
            @secondary="skipAirport"
        />
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import Errors from '@/components/errors.vue';
import LoungesAutoSuggest from '@/components/tools/lounges/lounges-search/lounges-autosuggest/lounges-autosuggest.vue';
import QuizActionBar from './QuizActionBar.vue';
import { useQuizWizard } from '@/composables/useQuizWizard';

const {
    saving, errors,
    selectedAirports, airportInputs, airportHasError,
    onAirportSelected, onAirportChange,
    saveAirport, skipAirport,
} = useQuizWizard();
</script>
